module.exports = __webpack_public_path__ + "static/media/waypoint_g.0182bf18.svg";